import React from "react";
import "../ResultScreen.css";

interface ResultFooterProps {
  onQuit: () => void;
  onRestart?: () => void;
  isSinglePlayer: boolean;
}

const ResultFooter: React.FC<ResultFooterProps> = ({
  onQuit,
  onRestart,
  isSinglePlayer,
}) => {
  return (
    <div className="result-screen-footer">
      {onRestart && (
        <button className="result-screen-button restart" onClick={onRestart}>
          {isSinglePlayer ? "Play Again" : "Restart Game"}
        </button>
      )}
      <button className="result-screen-button quit" onClick={onQuit}>
        Quit
      </button>
    </div>
  );
};

export default ResultFooter;

